import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ColorOption } from '../../../shared/models/appearance';
import { NgClass } from '@angular/common';

@Component({
  selector: 'motn-swatch',
  template: `
    <div
      class="swatch"
      [ngClass]="color"
      [style.margin]="margin"
      [style.--swatch-size.px]="size"
    >
      <i class="fa-solid fa-t"></i>
    </div>
  `,
  styleUrls: ['./swatch.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class SwatchComponent {
  @Input() color: ColorOption = '';
  @Input() margin: string = '10px';
  @Input() size: number = 28;
}